import { useCallback, useEffect, useState } from "react";
import { useUser } from "contexts/UserContext";
import { ping } from "services/ping";
import { refreshWebapp } from "services/buildVersion";
import { clearUserSession } from "services/users/auth";
import { useNavigate } from "react-router";
import { routes } from "pages/routes";
import { logError } from "services/logging";
import { SignInLocationState } from "pages/SignIn/SignIn";

const SESSION_CHECK_INTERVAL = 1000 * 30;

export default function useHeartbeat() {
  const user = useUser(false);
  const navigate = useNavigate();

  const [apiResponding, setApiResponding] = useState(true);

  const userId = user?.id ?? null;

  const pingServer = useCallback(() => {
    ping(
      response => {
        setApiResponding(true);

        if (response.user && response.user.id !== userId) {
          refreshWebapp();
        } else if (!response.user && userId) {
          clearUserSession();
          const state: SignInLocationState = {
            sessionExpired: true,
            returnPath: routes.public.signIn.path(),
          };
          navigate(routes.public.signIn.path(), {
            state,
          });
        }
      },
      error => {
        setApiResponding(false);
        logError(error);
      }
    );
  }, [userId, navigate]);

  useEffect(() => {
    const id = setInterval(pingServer, SESSION_CHECK_INTERVAL);
    return () => clearInterval(id);
  }, [pingServer]);

  return { apiResponding, pingServer };
}
